export const LOCAL_STORAGE_I18 = 'i18';